import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageHero";
import { IMAGES } from "@/data/content";
import { LEGAL_PAGES, BUSINESS } from "@/data/legal";
import { useLang } from "@/i18n/LanguageContext";
import { useSeo } from "@/hooks/useSeo";

// **bold** lead-ins inside legal paragraphs
const renderRich = (text) =>
  text.split(/\*\*([^*]+)\*\*/g).map((part, i) =>
    i % 2 === 1 ? <strong key={i} className="font-medium text-ink">{part}</strong> : part
  );

export default function LegalPage({ pageKey }) {
  const { lang } = useLang();
  const doc = (LEGAL_PAGES[pageKey] || {})[lang] || LEGAL_PAGES[pageKey].en;
  useSeo({ title: `${doc.title} | Women's Den`, description: doc.intro || doc.sections[0].paras[0] });
  return (
    <main className="bg-cream" data-testid={`legal-${pageKey}-page`}>
      <PageHero eyebrow={doc.eyebrow} title={doc.title} image={IMAGES.botanical} testid={`legal-${pageKey}-hero`} />
      <section className="mx-auto max-w-3xl px-6 pb-28">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-soft" data-testid={`legal-${pageKey}-updated`}>{doc.updated}</p>
          {doc.intro && (
            <p className="mt-8 font-serif italic text-xl leading-snug text-clay" data-testid={`legal-${pageKey}-intro`}>{doc.intro}</p>
          )}
          {doc.sections.map((s, i) => (
            <div key={i} className="mt-12" data-testid={`legal-${pageKey}-section-${i}`}>
              <h2 className="font-serif text-2xl tracking-tight text-ink">{s.heading}</h2>
              <div className="mt-4 space-y-4">
                {s.paras.map((p, j) => (
                  <p key={j} className="text-base leading-relaxed text-soft" style={{ whiteSpace: "pre-line" }}>{renderRich(p)}</p>
                ))}
              </div>
            </div>
          ))}
          <div className="mt-16 border-t border-ink/10 pt-8" data-testid="legal-business">
            <p className="text-xs tracking-[0.25em] uppercase text-soft mb-4">{BUSINESS.title[lang] || BUSINESS.title.en}</p>
            <address className="not-italic text-sm leading-relaxed text-soft">
              {BUSINESS.lines.map((l) => <span key={l} className="block">{l}</span>)}
            </address>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
